import { render, staticRenderFns } from "./totalConsumption.vue?vue&type=template&id=28f4e806&scoped=true&"
import script from "./totalConsumption.vue?vue&type=script&lang=js&"
export * from "./totalConsumption.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/bs-helpers.css?vue&type=style&index=0&id=28f4e806&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4e806",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
